export default "__VITE_ASSET__Dtr5Uwzk__"